// @ts-nocheck
document.addEventListener("alpine:init", () => {
  Alpine.data("productForm", () => ({
    sellingPlan: null,
    isOtpOnlyVariant: true,

    init() {
      window.addEventListener('variant:update', this.updateProductForm.bind(this));
      
      // Initialize from pre-checked variant on page load
      this.initFromCheckedVariant();
    },

    initFromCheckedVariant() {
      const checkedInput = document.querySelector('.ctr-variant-default-picker input[type="radio"]:checked');
      if (checkedInput) {
        this.isOtpOnlyVariant = checkedInput.dataset.otpOnlyVariant === 'true';
        const sellingPlanId = checkedInput.dataset.sellingPlanId;
        this.sellingPlan = this.isOtpOnlyVariant ? null : (sellingPlanId || null);
      }
    },

    updateProductForm(event) {
      this.setPurchaseType(event.detail.resource.id);
      this.setSellingPlan(event.detail.resource.selling_plan_allocations[0]?.selling_plan_id);

      document.querySelector('input[data-radio-subsave]')?.setAttribute('disabled', 'true');
      document.querySelector('input[data-radio-onetime]')?.setAttribute('disabled', 'true');
    },

    setSellingPlan(sellingPlanId) {
      this.sellingPlan = this.isOtpOnlyVariant ? null : sellingPlanId;
    },

    setPurchaseType(variantId) {
      const optionEl = document.querySelector(`[data-variant-id="${variantId}"]`);

      if (optionEl && optionEl.dataset.otpOnlyVariant) {
        this.isOtpOnlyVariant = optionEl.dataset.otpOnlyVariant === 'true';
      } else {
        this.isOtpOnlyVariant = true;
      }
    },
  }));
});